import getRequest from 'utils/getRequest'

const path = '/api/eco-regions'

//eslint-disable-next-line
export const requestEcoRegionsSearch = (name, signal) => {
  return getRequest(`${path}/search?name=${name}`, signal)
}
